import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.applyTheme()
  }

  applyTheme() {
    const saved = localStorage.getItem("theme")
    if (saved === "light") {
      document.body.classList.remove("dark")
    } else {
      document.body.classList.add("dark")
    }
  }

  toggle() {
    const isDark = document.body.classList.toggle("dark")
    localStorage.setItem("theme", isDark ? "dark" : "light")
  }
}
